/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import clsx from 'clsx'
type Props = {
  passwordLabel: string
  passwordPlaceholder?: string
  passwordValue?: string
  passwordTouched?: any
  passwordErrors?: any
  passwordProps?: any
  isConfirmationActive?: boolean
  passwordStrictLabel?: string
  confirmLabel?: string
  confirmPlaceholder?: string
  confirmValue?: string
  confirmTouched?: any
  confirmErrors?: any
  confirmProps?: any
}

const PasswordWithLabel: React.FC<Props> = ({
  passwordLabel,
  passwordPlaceholder,
  passwordValue,
  passwordTouched,
  passwordErrors,
  passwordProps,
  isConfirmationActive,
  passwordStrictLabel,
  confirmLabel,
  confirmPlaceholder,
  confirmValue,
  confirmTouched,
  confirmErrors,
  confirmProps,
}) => {
  return (
    <>
      <div className='fv-row mb-8' data-kt-password-meter={isConfirmationActive}>
        <div className='mb-1'>
          <label className='form-label fw-bolder text-dark fs-6'>{passwordLabel}</label>
          <div className='position-relative mb-3'>
            <input
              type='password'
              placeholder={passwordPlaceholder}
              autoComplete='off'
              {...passwordProps}
              className={clsx(
                'form-control bg-transparent',
                {
                  'is-invalid': passwordTouched && passwordErrors,
                },
                {
                  'is-valid': passwordTouched && !passwordErrors,
                }
              )}
              value={passwordValue}
            />
            {passwordTouched && passwordErrors && (
              <div className='fv-plugins-message-container'>
                <div className='fv-help-block'>
                  <span role='alert'>{passwordErrors}</span>
                </div>
              </div>
            )}
          </div>
          <div
            className='d-flex align-items-center mb-3'
            data-kt-password-meter-control='highlight'
          >
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2'></div>
            <div className='flex-grow-1 bg-secondary bg-active-success rounded h-5px'></div>
          </div>
        </div>
        {isConfirmationActive && <div className='text-muted'>{passwordStrictLabel}</div>}
      </div>

      {isConfirmationActive && (
        <div className='fv-row mb-5'>
          <label className='form-label fw-bolder text-dark fs-6'>{confirmLabel}</label>
          <input
            type='password'
            placeholder={confirmPlaceholder}
            autoComplete='off'
            {...confirmProps}
            value={confirmValue}
            className={clsx(
              'form-control bg-transparent',
              {
                'is-invalid': confirmTouched && confirmErrors,
              },
              {
                'is-valid': confirmTouched && !confirmErrors,
              }
            )}
          />
          {confirmTouched && confirmErrors && (
            <div className='fv-plugins-message-container'>
              <div className='fv-help-block'>
                <span role='alert'>{confirmErrors}</span>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  )
}

export {PasswordWithLabel}
